module.exports = __webpack_public_path__ + "static/media/dropdown-arrow.29fb2053.svg";